module.exports = __webpack_public_path__ + "img/rzlogo_black.1631ebc8.png";